<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
      <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
        <div class="relative">
          <input type="text" [(ngModel)]="search" (input)="onSearchInput()" required placeholder="Search.." class="pl-8" />
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
        </div>
          <div>
            <select class="w-full sm:w-40" [(ngModel)]="selectedStatus" (change)="onSelectStatus()" id="inputStatus">
              <option [ngValue]="true">Active</option>
              <option [ngValue]="false">Inactive</option>
            </select>
          </div>
           <button [ngClass]="status ? 'btn-danger' : 'btn-primary'" *ngIf="selectedCompanies && selectedCompanies.length" (click)="bulkUpdate()" class="btn">
            {{status ? 'Mark Inactive' : 'Mark Active'}}
      </button>
      </div>
    <div *ngIf="filteredUsers && filteredUsers.length">
      <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (users.length!== 50? (50
        -users.length) : 0) }} of {{totalResults}} entries
      </h1>
    </div>
    <div *ngIf="permissionService.hasPermission([userPermission.MANAGE_SIGNUP])" class="flex gap-2">
      <button routerLink="add" class="btn btn-secondary">
        Add
      </button>
    </div>
  </div>

  <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>

                   <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    #
                  </th>

                  <ng-container *ngIf="permissionService.hasPermission([userPermission.MANAGE_SIGNUP])">
                  <th *ngIf="filteredUsers && filteredUsers.length > 0" class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <input type="checkbox" [checked]="selectedCompanies.length && selectedCompanies.length === filteredUsers.length"
                      (change)="onSelectAllCompanies($event)" />
                  </th>
                  </ng-container>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Action
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Name</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Contact No.</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Email</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Address</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Created At</th>
      
                </tr>
              </thead>
              <tbody>
                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                  *ngFor="let item of filteredUsers | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i = index " [ngClass]="{'bg-gray-950/5 dark:bg-white/10': item.isSelected}">
                  
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    {{i+1}}
                  </td>

                  <ng-container *ngIf="permissionService.hasPermission([userPermission.MANAGE_SIGNUP])">
                  <td *ngIf="filteredUsers && filteredUsers.length > 0" class="relative px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <div class="absolute inset-y-0 left-0 w-0.5 bg-main-primary" [ngClass]="{'hidden': !item.isSelected}"></div>
                    <input type="checkbox" [checked]="selectedCompanies.includes(item.id)" (change)="onSelectCompany(item)" />
                  </td>
                  </ng-container>


                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    <div class="flex">
                      <button [appToolTip]="'Detail'" (click)="opendetailModal(item)" class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="w-5 h-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        </svg>
                      </button>
                      <ng-container *ngIf="item.isCreated">
                        <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                        <button
                          class="btn btn-primary px-[calc(theme(spacing.2)-1px)] py-[calc(theme(spacing.1)-1px)] text-sm/5 font-medium sm:text-xs/5"
                          [ngClass]="{'badge-primary': item.isCreated}" [disabled]="item.isCreated">
                          Created
                        </button>
                      </ng-container>
                      <ng-container *ngIf="!item.isCreated && permissionService.hasPermission([userPermission.MANAGE_COMPANY]) && status == true">
                        <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                        <button (click)="createCompany(item)"
                          class="btn btn-primary px-[calc(theme(spacing.2)-1px)] py-[calc(theme(spacing.1)-1px)] text-sm/5 font-medium sm:text-xs/5"
                          [ngClass]="{'badge-primary': item.isCreated}" [disabled]="item.isCreated">
                          Create
                        </button>
                      </ng-container>
                    </div>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    {{(item.name | titlecase) || 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="item?.phoneNumber">
                    {{item.phoneNumber || 'N/A'}}
                  </td>
                    
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{item.email || 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{item.address?.name || 'N/A'}}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{(item.createdAt | date: 'MM/DD/YYYY')|| 'N/A'}}</td>
      
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    
    <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
  </div>
</section>

<app-signup-details-slideout *ngIf="signUpDetail" [signUpdetailObj]="signUpDetail"
  (closeModal)="signUpDetail = null"></app-signup-details-slideout>